import { render, staticRenderFns } from "./Mosaico.vue?vue&type=template&id=982db19c&"
import script from "./Mosaico.vue?vue&type=script&lang=js&"
export * from "./Mosaico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports